(() => {
  const HEADER_SELECTOR = '#header-component';
  const READY_ATTRIBUTE = 'data-as-sticky-compact-ready';
  const COMPACT_CLASS = 'as-header-compact';
  const ENTER_OFFSET = 18;
  const EXIT_OFFSET = 4;

  const initCompactStickyHeader = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!(header instanceof HTMLElement) || header.hasAttribute(READY_ATTRIBUTE)) return;

    let stickyStart = header.getBoundingClientRect().top + window.scrollY;
    let frame = 0;
    let isCompact = header.classList.contains(COMPACT_CLASS);
    let stateAnimation = null;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    header.setAttribute(READY_ATTRIBUTE, 'true');
    header.setAttribute('data-sticky-type', 'always');
    header.stickyMode = 'always';
    header.offscreen = false;

    if (header.intersectionObserver) {
      header.intersectionObserver.disconnect();
      header.intersectionObserver = null;
    }

    const animateStateChange = () => {
      const surface = header.querySelector('.header__row--top');
      if (!(surface instanceof HTMLElement) || reducedMotion.matches || typeof surface.animate !== 'function') return;

      if (stateAnimation) stateAnimation.cancel();

      stateAnimation = surface.animate(
        [
          { opacity: 0.72, transform: 'translateY(-7px) scaleY(0.985)' },
          { opacity: 1, transform: 'translateY(0) scaleY(1)' },
        ],
        {
          duration: 280,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        },
      );

      stateAnimation.addEventListener(
        'finish',
        () => {
          stateAnimation = null;
        },
        { once: true },
      );
    };

    const applyState = (nextCompact) => {
      if (nextCompact === isCompact) return;

      isCompact = nextCompact;
      header.classList.toggle(COMPACT_CLASS, isCompact);
      header.dataset.stickyState = isCompact ? 'active' : 'inactive';
      header.dataset.scrollDirection = isCompact ? 'down' : 'none';
      document.documentElement.classList.toggle('as-has-compact-header', isCompact);
      animateStateChange();
    };

    const update = () => {
      frame = 0;
      const threshold = stickyStart + (isCompact ? EXIT_OFFSET : ENTER_OFFSET);
      applyState(window.scrollY > threshold);
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    const recalculate = () => {
      if (!isCompact) {
        stickyStart = header.getBoundingClientRect().top + window.scrollY;
      }
      requestUpdate();
    };

    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', recalculate, { passive: true });
    window.addEventListener('orientationchange', recalculate, { passive: true });
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompactStickyHeader, { once: true });
  } else {
    initCompactStickyHeader();
  }

  document.addEventListener('shopify:section:load', initCompactStickyHeader);
})();
